import { render } from "./List1.vue?vue&type=template&id=9f0d7f30"
import script from "./List1.vue?vue&type=script&lang=ts"
export * from "./List1.vue?vue&type=script&lang=ts"

import "./List1.vue?vue&type=style&index=0&id=9f0d7f30&lang=scss"
script.render = render

export default script